import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */

import { PureComponent } from 'react';
import { jsx } from '@emotion/react';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { gridSize } from '@atlaskit/theme/constants';
import { contentStyles, taskStyles, decisionStyles, placeholderStyles } from './styles';
var Item = /*#__PURE__*/function (_PureComponent) {
  _inherits(Item, _PureComponent);
  var _super = _createSuper(Item);
  function Item() {
    _classCallCheck(this, Item);
    return _super.apply(this, arguments);
  }
  _createClass(Item, [{
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var _this$props = this.props,
        children = _this$props.children,
        placeholder = _this$props.placeholder,
        showPlaceholder = _this$props.showPlaceholder,
        itemType = _this$props.itemType;
      if (!showPlaceholder || !placeholder || children) {
        return null;
      }

      // TODO: Migrate away from gridSize
      // Recommendation: Replace gridSize with 8
      var offset = gridSize() * (itemType === 'TASK' ? 3 : 3.5);
      return jsx("span", {
        "data-testid": "task-decision-item-placeholder",
        "data-component": "placeholder",
        css: placeholderStyles(offset),
        contentEditable: false
      }, placeholder);
    }
  }, {
    key: "renderMessageAppearance",
    value: function renderMessageAppearance() {
      var _this$props2 = this.props,
        contentRef = _this$props2.contentRef,
        children = _this$props2.children,
        icon = _this$props2.icon,
        itemType = _this$props2.itemType,
        checkBoxId = _this$props2.checkBoxId,
        dataAttributes = _this$props2.dataAttributes,
        theme = _this$props2.theme;
      if (itemType === 'TASK') {
        return jsx("div", {
          css: taskStyles,
          id: "".concat(checkBoxId, "-wrapper")
        }, icon, this.renderPlaceholder(), jsx("div", _extends({
          "data-component": "content",
          css: contentStyles,
          ref: contentRef
        }, dataAttributes), children));
      } else if (itemType === 'DECISION') {
        return jsx("div", {
          css: decisionStyles(theme),
          "data-decision-wrapper": "true"
        }, icon, this.renderPlaceholder(), jsx("div", _extends({
          "data-component": "content",
          css: contentStyles,
          ref: contentRef
        }, dataAttributes), children));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderMessageAppearance();
    }
  }]);
  return Item;
}(PureComponent);
_defineProperty(Item, "defaultProps", {
  appearance: 'inline'
});
export { Item as default };